export const eventTypes = {
  pillExtract: 'PILL',
  blisterInsert: 'INSERT',
  blisterExtract: 'EXTRACT',
};

export const locationDisplayAccuracy = 4;
